import CONST from './Constant';

const createInitialState = () => ({
    files: [],
    isProcessing: false,
    processedCount: 0,
});

const INITIAL_STATE = createInitialState();

const Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONST.RESET:
            return createInitialState();
        case CONST.UPDATE_STATE:
            return {
                ...state,
                ...action.payload,
            };
        case CONST.UPDATE_FILES:
            return {
                ...state,
                files: action.payload,
            };
        default:
            return state;
    }
};

export default Reducer;
